__turbopack_context__.v({
  "h1": "Title-module-scss-module__6rfxea__h1",
  "h2": "Title-module-scss-module__6rfxea__h2",
  "h3": "Title-module-scss-module__6rfxea__h3",
  "h4": "Title-module-scss-module__6rfxea__h4",
  "h5": "Title-module-scss-module__6rfxea__h5",
  "title": "Title-module-scss-module__6rfxea__title",
});
